import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import { Button, Form, Message } from 'semantic-ui-react'
import { forgotPassword, confirmForgotPassword, isAuthenticated } from '../../services/self'
import logo from '../../Nlogo.png'




 export default class Recover extends PureComponent {

   state = {
     isSubmitting: false,
     signedIn: false,
     errorMessage: '',
     isOpen: false,
     success: false,
     resetComplete: false,
     submitted: false,
     username: '',
     code: '',
     newPassword: '',
     username2: ''
   }



   _forgotPassword = (event, serializedForm) => {
     event.preventDefault();

     forgotPassword(this.state.username);
     this.setState({success: true})
   }


   confirmForgotPassword = (event, serializedForm) => {
     event.preventDefault()
     this.setState({resetComplete: true})


     confirmForgotPassword(this.state.username2, this.state.code, this.state.newPassword)

   }


   render() {

console.log(` Success is:  ${this.state.success}`)

     return (
    <div className="none">

            <div className="App">
            <div className="Logo">
              <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
              <Link className="home-link" to='/'>Developer</Link>
            </div>

            <div className="Navbar-Div">
              <nav className="App-navbar">


                <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
                <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
                <Link className="Centered-link" to='/documentation'>Docs</Link>
                <Link className="Centered-link" to='/tools'>Tools</Link>
                <Link className="Centered-link" to='/community'>Community</Link>

                {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
                {isAuthenticated() ? (<Link className="right" to='' onClick={() => this.logout()}>Log out</Link>) : ''}
                {isAuthenticated() ? '' : (
                <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
                </span>
                )}


              </nav>
            </div>

            <div className="App-banner">

              Newforma World 2018 | October 2 - 5, 2018 | Connecting People, Projects and Information!

            </div>

    <div className="main-content">
      <div className="div80">

      <Form style={{paddingBottom: '40px'}} success={this.state.success} onSubmit={this._forgotPassword} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
        <Message>Enter username and click submit to receive reset email code.</Message>
        <Form.Input label='Username' name='username' onChange={ (e) => this.setState({ username: e.target.value }) }/>
        <Message success large header='Submitted' content={this.state.success ? 'If you have a registered account we have emailed you a reset code' : ''} />
        <Button style={{backgroundColor: '#003C4D'}} primary type='submit'>Submit</Button>
      </Form>


      <Form onSubmit={this.confirmForgotPassword} success={this.state.resetComplete} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
        <Message>Use form below to enter code received in email.</Message>
        <Form.Input label='Username' name='username2' onChange={ (e) => this.setState({ username2: e.target.value }) }/>
        <Form.Input label='Verification Code' name='verificationCode' onChange={ (e) => this.setState({ code: e.target.value }) }/>
        <Form.Input label='New Password' type='password' name='newPassword' onChange={ (e) => this.setState({ newPassword: e.target.value }) }/>

        <Message error content={this.state.errorMessage} />

        <Message success large header='Submitted' content={this.state.resetComplete ? 'Your password reset is complete.' : ''}/>
          <Button style={{backgroundColor: '#003C4D'}} primary type='submit'>Submit</Button>

      </Form>
</div>

  </div>
</div>
</div>
)}
}



/** WEBPACK FOOTER **
 ** ./src/pages/ForgotPassword/index.js
 **/